import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SupplierClaim')
export class SupplierClaim {
  @JsonProperty('id', Number, false) id: number = undefined;
  @JsonProperty('type', String, false) type: string = undefined;
  @JsonProperty('quantity', Number, false) quantity: number = undefined;
  @JsonProperty('value', Number, false) value: number = undefined;
}
